import { render, staticRenderFns } from "./PixPaymentTable.vue?vue&type=template&id=afc8ada2&scoped=true"
import script from "./PixPaymentTable.vue?vue&type=script&lang=js"
export * from "./PixPaymentTable.vue?vue&type=script&lang=js"
import style0 from "./PixPaymentTable.vue?vue&type=style&index=0&id=afc8ada2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afc8ada2",
  null
  
)

export default component.exports